import { render, staticRenderFns } from "./ScreeningItem.vue?vue&type=template&id=4af6e6de&scoped=true&"
import script from "./ScreeningItem.vue?vue&type=script&lang=js&"
export * from "./ScreeningItem.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningItem.vue?vue&type=style&index=0&id=4af6e6de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6e6de",
  null
  
)

export default component.exports